export type MovieAutoplayMode = 'trailer' | 'movie';

const KEY = 'ott_movie_autoplay_mode';

export function getMovieAutoplayMode(): MovieAutoplayMode {
  const stored = localStorage.getItem(KEY);
  if (stored === 'movie') return stored;
  return 'trailer'; // default
}

export function setMovieAutoplayMode(mode: MovieAutoplayMode): void {
  localStorage.setItem(KEY, mode);
}
